import {getInputsForBroker} from "./inputReader";

const calcAjaxCall = (containerEl, type, action=null) => {
    let data = new FormData();
    const input1 = getInputsForBroker(containerEl,1);
    const input2 = getInputsForBroker(containerEl,2);

    let endpointUrl = window.calcajax.ajaxurl;
    const nonce = window.calcajax.nonce;

    //endpointUrl += '?action=' + 'fx';

    data.append('input1', JSON.stringify(input1));
    if(!action) {
        data.append('action', 'oil');
    } else {
        data.append('action', action);
    }
    data.append('input2', JSON.stringify(input2));
    data.append('type', type);
    data.append('nonce', nonce);
    data.append('calculator', 'oil');

    const params = new URLSearchParams(data);


    return fetch(endpointUrl, {
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
            // 'X-WP-Nonce': nonce
        },

        credentials: 'same-origin',
//        headers: { 'X-WP-Nonce': nonce }, // Add nonce for WP REST API

        body: params
    });
}

export {
    calcAjaxCall
}